/** Привести ошибку к единому типу */
export const normalizeError = (error: unknown): Error => {
    if (error instanceof Error) return error;
    if (typeof error === 'string') return new Error(error);

    return new Error('unknown error');
};
